import Env from "./Models/Env";

const DEV : Env = {
  APP_KEY: "bcd45fa-abc345-777bcd-bde53-98089",
  BASE_URL: "https://sbx-server.sbx360.com/api",
  VERSION_APP: "3.8.11-20210118",
  PAYMENT_TYPE_CREDIT: "1c072072-c032-4b75-a55d-341a1405e884",
  CLOUD_SCRIPTS: {
    LOGIN: "9e45ddd5-14cb-4571-ad80-dc4dad8076ee",
    VALIDATE: "dc52c2e1-f123-4c08-baf1-51ff9dabece1",
    CREATE_USER: "b06c9170-4e5e-4149-8f5f-4f377be133e6",
    GET_SHIPMENT_SALTTO : "01b511ed-a293-4cc2-82e0-128bbda670b1",
    GET_SHIPMENT_WITH_KEY: "90525d85-9c75-411e-aaf1-e83a5eca0eb6"
  },
  TEMPLATES: {
    TEST: "b0898c38-7896-4db2-a550-3064d6e4a443"
  },
  DOMAIN: 98,
  PUBLIC_PATH: "https://sbx-server.sbx360.com/www/aurabastaging/",
  PUBLIC_SHIPMENT_PATH: "https://sbx-server.sbx360.com/www/aurabastaging/client/#/shipment?key=",
  TEST_MODE: false
};

const PROD: Env = {
  APP_KEY: "bcd45fa-abc345-777bcd-bde53-98089",
  BASE_URL: "https://sbx-server.sbx360.com/api",
  VERSION_APP: "3.8.11-20210118",
  PAYMENT_TYPE_CREDIT: "470e83a8-2d6e-4d86-ba8a-10a104713918",
  CLOUD_SCRIPTS: {
    LOGIN: "6670bc21-6e5b-49bf-9321-2b78e12103f6",
    VALIDATE: "91270825-75ce-4e94-bc57-bf25cae649e0",
    CREATE_USER: "0cab6fe5-9824-4515-ac4b-9305e02b80bd",
    GET_SHIPMENT_SALTTO : "5676a1a6-e962-40af-8352-d2b41767917e",
    GET_SHIPMENT_WITH_KEY: "aff57942-2925-498f-a393-52f61f5adc54"
  },
  TEMPLATES: {
    TEST: "b0898c38-7896-4db2-a550-3064d6e4a443"
  },
  DOMAIN: 37,
  PUBLIC_PATH: "https://sbx-server.sbx360.com/www/auraba/",
  PUBLIC_SHIPMENT_PATH: "http://localhost:3000/#/shipment?key=",
  TEST_MODE: false
};

let env: Env = DEV;

if (process.env.REACT_APP_ENVIRONMENT === "PROD") {
  env = PROD;
}

export default env;
